import { useCallback, useEffect } from 'react';

import { useSizeStore } from 'store/size';

export const controlsId = 'controls';
export const controlsHideClassName = 'controls-hide';

let timer: number;
const timeToHide = 2000;

function toggleClass(node: HTMLElement | null, type: 'show' | 'hide') {
    if (type === 'show') {
        node?.classList.remove(controlsHideClassName);
    } else {
        node?.classList.add(controlsHideClassName);
    }
}

/** Хук для отображения / скрытия элементов управления */
export function useFullSizeControls() {
    const { isFull } = useSizeStore();

    useEffect(() => {
        return () => {
            window.clearTimeout(timer);
        };
    }, []);

    return useCallback(() => {
        const controlsNode = document.getElementById(controlsId);

        window.clearTimeout(timer);
        if (isFull) {
            toggleClass(controlsNode, 'show');
            timer = window.setTimeout(() => {
                toggleClass(controlsNode, 'hide');
            }, timeToHide);
        } else {
            toggleClass(controlsNode, 'show');
        }
    }, [isFull]);
}
